export class TableModalEntity {
    title;
    columns;
    rows;
    tableId;

    constructor(title, columns, rows, tableId) {
        this.title = title;
        this.columns = columns;
        this.rows = rows;
        this.tableId = tableId;
    }
}